// Mobile Legends game config — values mirror what is currently hardcoded in
// mlbbdraftplan/src/components/DraftBoard.js. Phase 3 of the unify plan
// ports the MLBB board into this codebase reading from here.

const mlbb = {
  id: 'mlbb',
  name: 'Mobile Legends',

  // No GSI in MLBB, so live pick timers are impossible; maps are an
  // MLBB-only drafting concept (per-map drafts on the board).
  features: {
    gsi: false,
    maps: true,
    // mlbbdraftplan never enforced tier limits — everyone gets full access
    everyonePremium: true,
  },

  // Board positions (1–27). Mirrors the inline arrays in mlbbdraftplan's
  // DraftBoard.js (usBans/usPicks and their swapped variants).
  board: {
    positionCount: 27,
    radiantBans: [1, 4, 7, 27, 22],
    radiantPicks: [14, 15, 18, 23, 20],
    direBans: [2, 3, 5, 26, 21],
    direPicks: [13, 16, 17, 24, 25],
    // Sequence numbers rendered as large boxes — mlbbdraftplan's DraftState
    // version, which adds 20/25 to the dota list (kept verbatim).
    largeBoxSequences: ['8', '9', '13', '14', '15', '16', '17', '18', '20', '23', '24', '25'],
  },

  teams: { a: 'Blue', b: 'Red' },

  // MAP_BORDER_COLORS from mlbbdraftplan DraftBoard.js
  maps: [
    { name: 'General', color: { r: 160, g: 160, b: 160 } },
    { name: 'Broken Wall', color: { r: 255, g: 60, b: 60 } },
    { name: 'Dangerous Grass', color: { r: 57, g: 255, b: 20 } },
    { name: 'Expanding River', color: { r: 0, g: 200, b: 255 } },
    { name: 'Flying Cloud', color: { r: 255, g: 220, b: 0 } },
  ],

  heroes: {
    // Roster/images come from mlbbdraftplan src/utils/imageMapping.js;
    // ported in Phase 3.
    imageCdn: null,
    defaultImage: null,
    idSource: null,
  },

  firebaseProjectId: 'systemcomesfirst-1',

  // Web app credentials, copied from mlbbdraftplan/src/firebase/config.js
  firebase: {
    apiKey: "AIzaSyCxne6AuyfYwdo4VHu3OkEGsSf2dXfCeF0",
    authDomain: "systemcomesfirst-1.firebaseapp.com",
    projectId: "systemcomesfirst-1",
    storageBucket: "systemcomesfirst-1.firebasestorage.app",
    messagingSenderId: "960895246235",
    appId: "1:960895246235:web:50950605ecc4e442d80b3e",
    measurementId: "G-BMKW8S9NRL"
  },
};

export default mlbb;
